import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-101">
      <div className="max-w-xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-brand-gold/40 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden shadow-sm" data-id="element-103">
          <ShieldCheckIcon className="w-12 h-12 sm:w-16 sm:h-16 text-brand-gold mx-auto mb-4 sm:mb-6 relative z-10" data-id="element-104" />

          <h3 className="text-lg sm:text-2xl font-serif font-bold text-brand-text-main mb-3 sm:mb-4 relative z-10" data-id="element-105">
            🛡️ GARANZIA DI FERRO
          </h3>

          <p className="text-sm sm:text-base text-brand-text-main font-bold leading-relaxed mb-3 sm:mb-4 relative z-10" data-id="element-106">
            PROVALO SENZA RISCHI PER 7 GIORNI.
          </p>

          <p className="text-xs sm:text-sm text-brand-text-muted font-medium leading-relaxed relative z-10" data-id="element-107">
            Siamo così sicuri dell'efficacia del Metodo Mediterraneo™ che ti
            offriamo una settimana per provarlo. Se non senti che la tua vita è
            diventata più semplice e organizzata, ti rimborsiamo ogni centesimo.
            Senza domande e senza complicazioni.
          </p>
        </motion.div>
      </div>
    </section>;
}